































































































































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { applicationFormModule } from '../store/modules/ApplicationForm';
@Component
export default class VariableList extends Vue {
  @Prop() private variableList!: any;
  // @Prop() private options!: any;
  @Prop() private localList!: any;
  @Prop() private workTypeKikanNoMap: any;
  @Prop() private workTypeHeaderKeyMap: any;
  @Prop() private workTypeHeaderMap: any;

  private meisaiHeader: any = [];
  private gyoushuHeader: any = [];
  // 業者種別
  private isConst: boolean = applicationFormModule.CHECK_TYPE_CONST;
  private isConsul: boolean = applicationFormModule.CHECK_TYPE_CONSUL;
  // 20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
  private isMaintenance: boolean = applicationFormModule.CHECK_TYPE_MAINTENANCE;
  // 20210910 [01_調達区分_維持管理業務追加] ueda ADD End
  private isGoods: boolean = applicationFormModule.CHECK_TYPE_GOODS;
}
